import { StatisticsMolecule } from "../../molecules"
import logoUppiness from "../../../assets/icons/logoUppiness.svg";
import "./Statistics.scss"
import { MuteButton } from "../../atoms";
import { useTranslation } from "react-i18next";

const Statistics = () => {
    const { t } = useTranslation();

    return (
        <div className="statistics">
            <MuteButton />
            <div className="statistics_logo_container">
                <img className="statistics_logo" src={logoUppiness} alt="Uppiness Logo" />
            </div>
            <div className="congratulations"><span> {t("congratulationsText")} </span></div>
            <div className="statistics_molecule_wrapper">
                <StatisticsMolecule />
            </div>
        </div>
    );
};

export default Statistics;